import React from 'react'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import { InsertionFlowScreensProps } from '../../../../../../../@types/props-types'
import { FieldProps } from '../../../../../../../@types/types'
import Costs from '../../Costs'
import PriceField, { PriceFieldType } from '../../../basicInfo/fields/priceField/PriceField'
import { RecommendedPriceNotification } from '../../../basicInfo/recommended-price-notification/RecommendedPriceNotification'
import AdditionalCosts from '../../fields/additionalCosts/AdditionalCosts'
import HeatingCostsWithToggle from '../../fields/heatingCostsWithToggle/HeatingCostsWithToggle'
import DepositWithToggle from '../../fields/depositWithToggle/DepositWithToggle'
import Deposit from '../../fields/deposit/Deposit'
import { isWebView } from '../../../../../../../utils/navigation'
import { IconS24EuroCircle24 } from '@is24/cosma-ui-icons'
import PricePeriodTypeChips from '../../fields/pricePeriodTypeChips/PricePeriodTypeChips'
import { useIsRecommendedPriceEnabled } from '../../../../UseIsRecommendedPriceEnabled'
import { useIsDepositGuaranteeEnabled } from '../../../../UseIsDepositGuaranteeEnabled'
import { DepositGuarantee } from '../../fields/depositGuarantee/DepositGuarantee'
import { TotalRent } from '../../fields/totalRent/TotalRent'

export type WebViewCostsRentProps = {
  screenTooltip?: string
  showRentPeriodSelector?: boolean | undefined
  showColdRentInCosts?: boolean
}

const WebViewCostsRent: React.FC<InsertionFlowScreensProps<CostsScreenValidationResult> & WebViewCostsRentProps> = (
  props
) => {
  const showLabelWithTooltip = isWebView()
  const isRecommendedPriceEnabled = useIsRecommendedPriceEnabled()
  const isDepositGuaranteeEnabled = useIsDepositGuaranteeEnabled()

  const showRentPeriodSelector = props.showRentPeriodSelector ?? false
  const showColdRentInCosts = props.showColdRentInCosts ?? true

  return (
    <Costs {...props} headerKey='wizard.screen.costs.mobileNativeHeader' headerIcon={<IconS24EuroCircle24 />}>
      {(costsWrapperProps: FieldProps<CostsScreenValidationResult>) => (
        <div className='grid grid-flex gutter-vertical-l'>
          <div className='grid-item one-whole'>
            {showColdRentInCosts && (
              <>
                <PriceField
                  {...costsWrapperProps}
                  priceFieldType={PriceFieldType.COLD_RENT}
                  wrapperClassName={`grid-item one-whole${isRecommendedPriceEnabled ? ' margin-bottom-m' : ''}`}
                  showLabelWithTooltip={showLabelWithTooltip}
                />
                {isRecommendedPriceEnabled && <RecommendedPriceNotification />}
              </>
            )}
            {showRentPeriodSelector && (
              <PricePeriodTypeChips {...costsWrapperProps} wrapperClassName='grid-item one-whole margin-top-l' />
            )}
            <AdditionalCosts
              {...costsWrapperProps}
              wrapperClassName={`grid-item one-whole${showColdRentInCosts ? ' margin-top-l' : ''}`}
              showLabelWithTooltip={showLabelWithTooltip}
            />

            {isDepositGuaranteeEnabled ? (
              <>
                <Deposit {...costsWrapperProps} showLabelWithTooltip={showLabelWithTooltip} />
                <DepositGuarantee
                  isAllowed={costsWrapperProps.insertionData.isDepositGuaranteeAllowed ?? false}
                  showDetailsLink={true}
                  onChange={(value) =>
                    costsWrapperProps.onChange(
                      {
                        screen: costsWrapperProps.screenName,
                        property: 'isDepositGuaranteeAllowed',
                      },
                      value
                    )
                  }
                />
                <HeatingCostsWithToggle {...costsWrapperProps} doReset={props.doReset!} />
                <TotalRent insertionData={costsWrapperProps.insertionData} />
              </>
            ) : (
              <>
                <HeatingCostsWithToggle {...costsWrapperProps} doReset={props.doReset!} />
                <TotalRent insertionData={costsWrapperProps.insertionData} />
                {showLabelWithTooltip ? (
                  <DepositWithToggle {...costsWrapperProps} doReset={props.doReset!} />
                ) : (
                  <Deposit {...costsWrapperProps} />
                )}
              </>
            )}
          </div>
        </div>
      )}
    </Costs>
  )
}

export default WebViewCostsRent
